import React, { useState } from "react";
import api from "../../config/axios";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

interface Props {
  table: {
    _id: string;
    name: string;
    seats: number;
  };
  onClose: () => void;
}

const ReservationForm: React.FC<Props> = ({ table, onClose }) => {
  const [customerName, setCustomerName] = useState("");
  const [customerPhone, setCustomerPhone] = useState("");
  const [peopleCount, setPeopleCount] = useState(1);
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [note, setNote] = useState("");
  const [message, setMessage] = useState("");
  const [timeError, setTimeError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setTimeError("");
    if (!selectedDate || selectedDate < new Date()) {
      setTimeError("Không thể đặt bàn cho thời điểm đã qua!");
      return;
    }
    const phoneRegex = /^0\d{9}$/;
    if (!phoneRegex.test(customerPhone)) {
      setPhoneError("Số điện thoại phải gồm 10 số và bắt đầu bằng 0");
      return;
    } else {
      setPhoneError("");
    }
    try {
      const res = await api.post("/api/tables/reserve", {
        tableId: table._id,
        customerName,
        customerPhone,
        peopleCount,
        time: selectedDate ? selectedDate.toISOString() : "",
        note,
      });
      const reservationId = res.data._id || res.data.data?._id;
      setMessage("Đặt bàn thành công!");
      setTimeout(() => {
        if (reservationId) {
          navigate(`/order/reserve/${reservationId}`);
        } else {
          window.location.reload();
        }
      }, 1200);
    } catch (err: any) {
      setMessage(err.response?.data?.message || "Có lỗi xảy ra");
    }
  };

  return (
    <div className="reservation-form">
      <h3>Đặt bàn: {table.name}</h3>
      <form onSubmit={handleSubmit}>
        <label htmlFor="customerName" className="reservation-label">Tên khách hàng</label>
        <input
          id="customerName"
          className="reservation-input"
          type="text"
          placeholder="Tên khách hàng"
          value={customerName}
          onChange={e => setCustomerName(e.target.value)}
          required
        />
        <label htmlFor="customerPhone" className="reservation-label">Số điện thoại</label>
        <input
          id="customerPhone"
          className="reservation-input"
          type="tel"
          placeholder="Số điện thoại"
          value={customerPhone}
          onChange={e => setCustomerPhone(e.target.value)}
          required
        />
        {phoneError && <div style={{ color: 'red', marginBottom: 8 }}>{phoneError}</div>}
        <label htmlFor="peopleCount" className="reservation-label">Số lượng người</label>
        <input
          id="peopleCount"
          className="reservation-input"
          type="number"
          placeholder="Số lượng người"
          value={peopleCount}
          min={1}
          max={table.seats}
          onChange={e => setPeopleCount(Number(e.target.value))}
          required
        />
        <label htmlFor="time" className="reservation-label">Thời gian</label>
        <div className="reservation-datepicker-wrapper">
          <DatePicker
            id="time"
            className="reservation-input reservation-datepicker"
            selected={selectedDate}
            onChange={(date: Date | null) => setSelectedDate(date)}
            showTimeSelect
            timeFormat="HH:mm"
            timeIntervals={15}
            dateFormat="dd/MM/yyyy HH:mm"
            minTime={(() => { const d = new Date(); d.setHours(7,0,0,0); return d; })()}
            maxTime={(() => { const d = new Date(); d.setHours(22,0,0,0); return d; })()}
            minDate={new Date()}
            placeholderText="Chọn ngày và giờ"
            timeCaption="Giờ"
          />
          {timeError && <div style={{ color: 'red', marginBottom: 8 }}>{timeError}</div>}
        </div>
        <label htmlFor="note" className="reservation-label">Ghi chú (nếu có)</label>
        <textarea
          id="note"
          className="reservation-input reservation-textarea"
          placeholder="Ghi chú"
          value={note}
          onChange={e => setNote(e.target.value)}
        />
        <button type="submit">Đặt bàn</button>
        <button type="button" onClick={onClose}>Hủy</button>
      </form>
      {message && <p>{message}</p>}
    </div>
  );
};

export default ReservationForm; 